import React from "react";
import Button from "react-bootstrap/Button";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className=" container">
        <div className="content">
          <h1>Good food choices are good investments.</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et
            purus a odio finibus bibendum amet leo
          </p>
          <div className="buttons">
            <Button className="button">
              Order Now
              <i class="fa-solid fa-basket-shopping"></i>
            </Button>
            <Button className="button">
              Learn More
              <i class="fa-solid fa-chevron-right"></i>
            </Button>
          </div>
        </div>
        <div className="img">
          <img src="hero-bg.jpg" alt="food-img" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
